/**
 * @fileoverview Utility functions for converting literal strings to boolean values.
 */

/**
 * Converts literal string values to boolean.
 * Useful when dealing with storage systems that store booleans as strings.
 *
 * @param {string} value The string value to convert to boolean.
 * @returns {boolean} True if value is "true", false otherwise.
 */
export const literalStringToBoolean = (value: string): boolean => {
  switch (value) {
    case "true":
      return true;
    case "false":
      return false;
    default:
      return false;
  }
};
